import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { API_CONFIG } from '../services/staticDataConfig';

interface Assinatura {
  status_assinatura: string;
  dias_restantes: number;
  plano_id: number;
}

// Event emitter simples para avisar o banner global (Soft Block)
export const subscriptionEvent = new EventTarget();

export const SubscriptionBadge: React.FC = () => {
  const [assinatura, setAssinatura] = useState<Assinatura | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAssinatura = async () => {
      try {
        if (!authService.isAuthenticated()) return;
        
        const response = await fetch(`${API_CONFIG.BASE_URL}/empresas/minha-assinatura`, {
          headers: {
            'Authorization': `Bearer ${authService.getToken()}`
          }
        });
        
        const result = await response.json();
        if (result.sucesso && result.dados) {
          setAssinatura(result.dados);
          
          // Emitir evento para o TrialBanner global
          subscriptionEvent.dispatchEvent(new CustomEvent('subscription_loaded', { detail: result.dados }));
        }
      } catch (error) {
        console.error('Erro ao buscar assinatura:', error);
      }
    };

    fetchAssinatura();
  }, []);

  if (!assinatura) return null;

  if (assinatura.status_assinatura === 'trial') {
    return (
      <li className="nav-item d-flex align-items-center mr-3">
        <span className="badge badge-warning text-dark mr-2 px-2 py-1" style={{ fontSize: '0.85rem' }}>
          <i className="fas fa-clock mr-1"></i> Trial: {assinatura.dias_restantes} dias
        </span>
        <button 
          onClick={() => navigate('/pagamento')} 
          className="btn btn-sm btn-success font-weight-bold"
          style={{ padding: '0.15rem 0.5rem', fontSize: '0.8rem' }}
        >
          <i className="fas fa-star mr-1"></i> Renovar
        </button>
      </li>
    );
  }

  if (assinatura.status_assinatura === 'expirado') {
    return (
      <li className="nav-item d-flex align-items-center mr-3">
        <span className="badge badge-danger mr-2 px-2 py-1" style={{ fontSize: '0.85rem' }}>
          <i className="fas fa-lock mr-1"></i> Trial Expirado
        </span>
        <button 
          onClick={() => navigate('/pagamento')} 
          className="btn btn-sm btn-success font-weight-bold"
          style={{ padding: '0.15rem 0.5rem', fontSize: '0.8rem' }}
        >
          Renovar Agora
        </button>
      </li>
    );
  }

  // Se for ativo, não precisa mostrar nada chamativo ou pode mostrar um "Pro"
  return (
    <li className="nav-item d-flex align-items-center mr-3">
      <span className="badge badge-primary px-2 py-1" style={{ fontSize: '0.8rem', opacity: 0.8 }}>
        <i className="fas fa-check-circle mr-1"></i> Plano Ativo
      </span>
    </li>
  );
};

export default SubscriptionBadge;
